<template>
  <div class="kpt-document-search-results" :class="{ 'more-than-3': results.length > 3 }">
    <div v-if="results.length">
      <document-result :result="result" v-for="(result, idx) in results" :key="idx" @null-search="nullSearch"></document-result>
    </div>
    <div v-else>No results found for your query.</div>
  </div>
</template>
<script>
import DocumentResult from './DocumentResultComponent.vue';

export default {
  components: {
    DocumentResult
  },
  props: {
    results: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean
    }
  },
  methods: {
    nullSearch() {
      // bubble the event to clear the search results so the download/view initiates
      this.$emit('null-search');
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-document-search-results {
  height: calc(100vh - 358px);
  overflow-y: auto;
  
  .more-than-3 {
    padding-right: 12px;
  }
}
</style>
